import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme } from '@mui/material';

export const MuiList: {
    defaultProps?: ComponentsProps['MuiList'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiList'];
    variants?: ComponentsVariants['MuiList'];
} = {
    styleOverrides: {
        root: {
            'li::before': {
                content: '""',
            },
        },
    },
};
